import {
  GrcTooltip,
  GrcTooltipPosition,
  FontAwesomeIcon,
  IconProp,
  facircleinfoclassicregular,
  fatablelistclassicregular,
  fachartpiesimpleclassicregular
} from '@grc/ui-package';
import { useHomeStore } from '../../../stores/home-store';
import { useI18nState } from '../../../stores/settings/language-context';
import './view-toggle.scss';

export default function ViewToggle() {
  const { localeData } = useI18nState();
  const [selectedView, setSelectedView] = useHomeStore(
    store => store.selectedView
  );
  const isBiView = selectedView === 'bi';

  return (
    <div
      className="home-view-toggle d-flex align-items-center"
      data-testid="home_view_toggle"
    >
      <span className="home-view-toggle-label me-2">
        {isBiView ? localeData.BiView : localeData.OperationalView}
      </span>

      <div
        className="home-view-toggle-switch"
        role="group"
        aria-label={`${localeData.OperationalView} / ${localeData.BiView}`}
      >
        <button
          type="button"
          className={`home-view-toggle-option${!isBiView ? ' is-active' : ''}`}
          aria-pressed={!isBiView}
          title={localeData.OperationalView}
          data-testid="home_view_toggle_operational"
          onClick={() => setSelectedView({ selectedView: 'operational' })}
        >
          <FontAwesomeIcon icon={fatablelistclassicregular as IconProp} />
        </button>
        <button
          type="button"
          className={`home-view-toggle-option${isBiView ? ' is-active' : ''}`}
          aria-pressed={isBiView}
          title={localeData.BiView}
          data-testid="home_view_toggle_bi"
          onClick={() => setSelectedView({ selectedView: 'bi' })}
        >
          <FontAwesomeIcon icon={fachartpiesimpleclassicregular as IconProp} />
        </button>
      </div>

      <GrcTooltip
        title={localeData.HomeViewInfoTooltip}
        position={GrcTooltipPosition.Top}
      >
        <span
          className="home-view-toggle-info ms-2"
          role="img"
          aria-label={localeData.HomeViewInfoTooltip}
        >
          <FontAwesomeIcon icon={facircleinfoclassicregular as IconProp} />
        </span>
      </GrcTooltip>
    </div>
  );
}
